import DataLoadError, {
  DataLoadDefaultErrors,
} from "../../../utils/data-load-error/data-load-error";

export enum GpsCargoOrderRecordsErrorType {
  GATEWAY_TIMEOUT = "GATEWAY_TIMEOUT",
}

export type GpsCargoOrderRecordsErrorGatewayTimeout = DataLoadError<
  GpsCargoOrderRecordsErrorType.GATEWAY_TIMEOUT,
  {}
>;

type GpsCargoOrderRecordsError =
  | GpsCargoOrderRecordsErrorGatewayTimeout
  | DataLoadDefaultErrors;

export default GpsCargoOrderRecordsError;
